import TableWithCheckboxes from "../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes";
import {headCells} from "./EsitoInvioEmailTableHelper";
import {IconButton, TableCell, TableRow, Tooltip} from "@material-ui/core";
import RepeatIcon from '@material-ui/icons/Repeat';
import HelpIcon from "@material-ui/icons/Help";
import EmptyRow from "../../../../../ui/tables/rows/empty-row/EmptyRow";
import Checkbox from "@material-ui/core/Checkbox";
import {returnSelectedRows} from "../../../../../../shared/utils/tableUtils";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getEsitoInvioEmailTableData} from "../../../../../../store/e-sim/actions";
import {addPlusForMsisdn} from "../../../../../../shared/utils/utils";
import {formatMissingData} from "shared/utils/formatDataUtils";

const EsitoInvioEmailTable = (props) => {
    const dispatch = useDispatch();
    const tableLoading = useSelector(state => state.eSimReducer.esitoInvioEmailTableData.loading);
    const tableData = useSelector(state => state.eSimReducer.esitoInvioEmailTableData.data);
    const total = useSelector(state => state.eSimReducer.esitoInvioEmailTableData.total);
    const integrationId = useSelector((state) => state.authReducer.selectedCompany.integrationId);

    useEffect(() => {
        dispatch(getEsitoInvioEmailTableData(props.filter, props.sort, props.page, props.rowsPerPage))
    }, [dispatch, props.filter, props.page, props.sort, props.rowsPerPage, integrationId])

    const handleCheckboxClick = (e, row) => {
        e.stopPropagation()
        const selectedIndex = props.selected.findIndex(i => i.id === row.id);
        props.setSelected(returnSelectedRows(props.selected, row, selectedIndex));
    }

    const isSelected = (id) => props.selected.some(d => d.id === id);

    const tableRows = (
        tableData.length !== 0 ?
            tableData.map((row, idx) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `esito-invio-email-table-checkbox-${idx}`;

                return (
                    <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}>
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={isItemSelected}
                                onClick={(e) => handleCheckboxClick(e, row)}
                                inputProps={{'aria-labelledby': labelId}}
                            />
                        </TableCell>
                        <TableCell align="left">{row.idLotto}{row.idLottoPopupText &&
                            <Tooltip title={formatMissingData(row.idLottoPopupText)} arrow style={{marginLeft:"3px"}}>
                                <IconButton size={"small"}  color={"secondary"}>
                                   <RepeatIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>}
                        </TableCell>
                        <TableCell align="left">{addPlusForMsisdn(row.numeroDiTelefono)}
                        {row.numeroDiTelefono === null &&
                            <Tooltip title={row.numTelefonoPopupText} arrow>
                                <IconButton size={"small"}>
                                <HelpIcon color="primary" fontSize="small"/>
                                </IconButton>
                            </Tooltip>}
                        </TableCell>
                        <TableCell align="left">{formatMissingData(row.seriale)}</TableCell>
                        <TableCell align="left">{row.indirizzoEmail}</TableCell>
                        <TableCell align="left">{row.dataInvio}</TableCell>
                        <TableCell align="left">{formatMissingData(row.esitoInvio)}{row.esitoInvioPopupText &&
                            <Tooltip title={row.esitoInvioPopupText} arrow>
                                <IconButton size={"small"}>
                                <HelpIcon color="primary" fontSize="small"/>
                                </IconButton>
                            </Tooltip>}
                        </TableCell>
                    </TableRow>
                )
            }) : <EmptyRow text="dato" colSpan={headCells.length + 2}/>
    )

    return (
        <TableWithCheckboxes
            selected={props.selected}
            setSelected={props.setSelected}
            page={props.page}
            rowsPerPage={props.rowsPerPage}
            fetchData={props.handlePaginationChange}
            count={total}
            loading={tableLoading}
            tableRows={tableRows}
            rows={tableData}
            headCells={headCells}
            selectAllRows={props.areAllSelected}
            setSelectAllRows={props.setAreAllSelected}
        />
    )
};

EsitoInvioEmailTable.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired,
}

export default EsitoInvioEmailTable;
